import React from 'react';
import { useTranslation } from 'react-i18next';
import { select } from '@panel/commons/core/themev2';
import { Icon } from '@panel/commons';
import { formatAmount } from '@panel/commons/helpers/formatAmount';
import { site } from '@panel/commons/helpers';
import {
  PreviewContainer,
  PostingImageWrapper,
  PostingInfoWrapper,
  BlockInfo,
  Pill,
  Rates,
  AddressBox,
  FeaturesBox,
  PostingTitle,
  PostingDescription
} from './styles';

const siteId = site.id;

function PreviewMobile({ planInfo, postingPreview }) {
  const { address, description, features, location, prices, title, urlPicture } = postingPreview;
  const { t } = useTranslation();

  return (
    <PreviewContainer data-repa='step3mod3-mobilePreview-container'>
      <PostingImageWrapper data-repa='step3mod3-mobilePreview-imgWrapper'>
        <Pill
          data-repa='step3mod3-mobilePreview-pill'
          bottom='15'
          right='15'
          color='midDarkGray'
          borderColor='midDarkGray'
          className={planInfo.highlight.toUpperCase()}
        >
          {planInfo.name}
        </Pill>
        <img src={urlPicture} alt={title} data-repa='step3mod3-mobilePreview-img' />
      </PostingImageWrapper>
      <PostingInfoWrapper>
        <div>
          <BlockInfo layout='row' content='space-between'>
            <Rates data-repa='step3mod3-mobilePreview-rates'>
              <h2 data-repa='step3mod3-mobilePreview-rates-price' className='price'>
                {formatAmount(prices[0].amount, prices[0].currency)}
              </h2>
              <p data-repa='step3mod3-mobilePreview-rates-price-label'>
                {features.CFT6 &&
                  `+ ${formatAmount(features.CFT6.value, null, true)}${t('publisher.step4.module3.preview.expenses')}`}
              </p>
            </Rates>
          </BlockInfo>
          <BlockInfo>
            <AddressBox data-repa='step3mod3-mobilePreview-address'>
              <h2 data-repa='step3mod3-mobilePreview-address-label'>{address}</h2>
              <p data-repa='step3mod3-mobilePreview-address-location'>{location}</p>
            </AddressBox>
          </BlockInfo>
          <BlockInfo layout='column'>
            <FeaturesBox data-repa='step3mod3-mobilePreview-features'>
              {features.CFT100 && (
                <div data-repa='step3mod3-mobilePreview-features100'>
                  <Icon name='meters' width={16} height={17} viewBox='0 0 16 17' colorFill={select('midDarkGray')} />
                  <span>{`${features.CFT100.value} ${features.CFT100.value_unit}`}</span>
                </div>
              )}
              {!features.CFT100 && features.CFT101 && (
                <div data-repa='step3mod3-mobilePreview-features101'>
                  <Icon name='meters' width={16} height={17} viewBox='0 0 16 17' colorFill={select('midDarkGray')} />
                  <span>{`${features.CFT101.value} ${features.CFT101.value_unit}`}</span>
                </div>
              )}
              {siteId === 'ZPAR' && features.CFT1 && (
                <div data-repa='step3mod3-mobilePreview-features1'>
                  <Icon name='dorms' width={16} height={17} viewBox='0 0 16 17' colorFill={select('midDarkGray')} />
                  <span>
                    {features.CFT1.value} {t('publisher.step4.module3.preview.features2')}
                  </span>
                </div>
              )}
              {siteId !== 'ZPAR' && features.CFT2 && (
                <div data-repa='step3mod3-mobilePreview-features2'>
                  <Icon name='dorms' width={16} height={17} viewBox='0 0 16 17' colorFill={select('midDarkGray')} />
                  <span>
                    {features.CFT2.value} {t('publisher.step4.module3.preview.features2')}
                  </span>
                </div>
              )}
              {features.CFT3 && (
                <div data-repa='step3mod3-mobilePreview-features3'>
                  <Icon name='toilets' width={16} height={17} viewBox='0 0 16 17' colorFill={select('midDarkGray')} />
                  <span>
                    {features.CFT3.value} {t('publisher.step4.module3.preview.features3')}
                  </span>
                </div>
              )}
              <div data-repa='step3mod3-mobilePreview-features7'>
                <Icon name='garage' width={16} height={17} viewBox='0 0 16 17' colorFill={select('midDarkGray')} />
                <span>
                  {features.CFT7
                    ? `${features.CFT7.value}  ${t('publisher.step4.module3.preview.features4')}`
                    : t('publisher.step4.module3.preview.features4b')}
                </span>
              </div>
            </FeaturesBox>
            <PostingTitle data-repa='step3mod3-mobilePreview-postingTitle'>{title}</PostingTitle>
            <PostingDescription data-repa='step3mod3-mobilePreview-postingDesc'>
              {description.slice(0, 50)}...
            </PostingDescription>
          </BlockInfo>
        </div>
      </PostingInfoWrapper>
    </PreviewContainer>
  );
}

export { PreviewMobile };
